/* ============================================================
   ALPHA VITAL — theme.js
   Core JS: Drawers · Cart · Search · Reveal · Misc
   ============================================================ */
(function () {
  'use strict';

  var lastTrigger = null;
  function restoreTrigger() {
    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      try { lastTrigger.focus(); } catch (e) {}
      lastTrigger = null;
    }
  }

  /* ── Fokus-Falle für modale Dialoge (Drawer, Such-Overlay, Menü, Popup) ──
     Hält Tab/Shift+Tab im offenen Dialog (WCAG 2.4.3 / BFSG-EAA). Ein Trap aktiv. */
  var _trapEl = null, _trapHandler = null;
  function trapFocus(el) {
    releaseFocus();
    if (!el) return;
    _trapEl = el;
    _trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var nodes = el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var vis = [];
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (!(n.offsetWidth || n.offsetHeight || n.getClientRects().length)) continue;
        if (getComputedStyle(n).visibility === 'hidden') continue;  /* eingeklappte Subnavs/Flyout ausschließen */
        vis.push(n);
      }
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    el.addEventListener('keydown', _trapHandler);
  }
  function releaseFocus() {
    if (_trapEl && _trapHandler) _trapEl.removeEventListener('keydown', _trapHandler);
    _trapEl = null; _trapHandler = null;
  }
  /* Für externe Section-Scripts (Mobile-Menü in section-header.js, email-popup) */
  window.avTrapFocus = trapFocus;
  window.avReleaseFocus = releaseFocus;

  /* ── DrawerManager ── */
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    el.querySelector('[autofocus], input, button')?.focus();
    trapFocus(el);
    document.dispatchEvent(new CustomEvent('drawer:opened', { detail: { id } }));
  }
  function closeDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    releaseFocus();
    restoreTrigger();
    document.dispatchEvent(new CustomEvent('drawer:closed', { detail: { id } }));
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open], .js-cart-open, .js-search-open');
    if (openBtn) {
      lastTrigger = openBtn;
      openBtn.setAttribute('aria-expanded', 'true');
      if (openBtn.classList.contains('js-cart-open')) { openDrawer('cart-drawer'); return; }
      if (openBtn.classList.contains('js-search-open')) { openSearchOverlay(); return; }
      var target = openBtn.dataset.drawerOpen;
      if (target) openDrawer(target);
    }
    var closeBtn = e.target.closest('.js-drawer-close, .js-search-close');
    if (closeBtn) {
      var id = closeBtn.dataset.drawer;
      if (id) closeDrawer(id);
      else closeSearchOverlay();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { closeDrawer(d.id); });
    closeSearchOverlay();
  });

  /* ── Search Overlay ── */
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput = document.querySelector('.js-search-input');

  function openSearchOverlay() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { searchInput?.focus(); }, 80);
    trapFocus(searchOverlay);
  }
  function closeSearchOverlay() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    releaseFocus();
    restoreTrigger();
  }

  /* Live-Vorschläge im Mobile-Such-Overlay übernimmt predictive-search.js
     (Overlay ist mit data-predictive markiert). Der frühere lokale Fetch verwarf
     seine Antwort und wurde entfernt. */

  /* ── Cart AJAX ── */
  function updateCartCount(count) {
    document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  /* Ersetzt Body + Fuß des Drawers aus frisch gerendertem cart-drawer-Section-HTML.
     - Fuß erscheint/verschwindet korrekt (leer <-> Artikel).
     - Fokus + Wert einer gerade bearbeiteten Mengen-Eingabe bleiben erhalten.
     - Eine noch nicht gespeicherte Bestellnotiz wird über den Re-Render gerettet. */
  function renderDrawer(html) {
    if (!html) return;
    var live = document.querySelector('#cart-drawer');
    if (!live) return;

    /* Flüchtigen Zustand sichern, den ein innerHTML-Replace zerstören würde */
    var active = document.activeElement;
    var focusKey = (active && active.classList && active.classList.contains('js-qty-input') && live.contains(active)) ? active.dataset.key : null;
    var noteEl = live.querySelector('.js-cart-note');
    var noteVal = noteEl ? noteEl.value : null;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('#cart-drawer') || doc.body;

    var newBody = src.querySelector('.js-cart-drawer-body');
    var curBody = live.querySelector('.js-cart-drawer-body');
    if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;

    var panel = live.querySelector('.drawer__panel');
    var curFoot = panel ? panel.querySelector('.drawer__foot') : null;
    var newFoot = src.querySelector('.drawer__foot');
    if (newFoot) {
      var clone = newFoot.cloneNode(true);
      if (curFoot) curFoot.replaceWith(clone);
      else if (panel) panel.appendChild(clone);
    } else if (curFoot) {
      curFoot.remove();
    }

    /* Ungespeicherte Notiz zurückschreiben */
    if (noteVal) {
      var newNote = live.querySelector('.js-cart-note');
      if (newNote && !newNote.value) newNote.value = noteVal;
    }
    /* Fokus auf die zuvor bearbeitete Mengen-Eingabe zurücksetzen (Cursor ans Ende) */
    if (focusKey) {
      var again = live.querySelector('.js-qty-input[data-key="' + focusKey + '"]');
      if (again) { again.focus(); var v = again.value; again.value = ''; again.value = v; }
    }
  }

  /* Cart-Mutationen serialisiert ausführen → keine überlappenden Requests, kein Flackern.
     `sections` liefert das frische Drawer-HTML atomar in derselben Antwort. */
  var cartChain = Promise.resolve();
  function cartMutate(url, payload) {
    payload.sections = 'cart-drawer';
    var run = cartChain.then(function () {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); });
    });
    cartChain = run.catch(function () {});
    return run;
  }

  /* Kurzer, sichtbarer Hinweis im Drawer (z. B. ausverkauft / Netzwerkfehler) */
  function cartFlash(msg) {
    var body = document.querySelector('#cart-drawer .js-cart-drawer-body');
    if (!body) return;
    var old = body.querySelector('.cart-flash');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'cart-flash';
    el.setAttribute('role', 'alert');
    el.textContent = msg;
    body.insertBefore(el, body.firstChild);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 5000);
  }

  /* Count IN der Chain lesen → kein Zähler-Flackern gegen parallele Änderungen */
  function syncCount() {
    var run = cartChain.then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    });
    cartChain = run.catch(function () {});
    return run.then(function (cart) { if (cart) updateCartCount(cart.item_count); }).catch(function () {});
  }

  /* Add to cart — Produktseite (.js-atc), Sticky-ATC (form="…") und Produktkarten (.js-quick-add) */
  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('.js-atc, .js-quick-add');
    if (!atcBtn || atcBtn.disabled) return;
    e.preventDefault();

    /* Formular: umschließend ODER per form="id"-Attribut referenziert (Sticky-Kaufleiste) */
    var form = atcBtn.closest('form');
    if (!form && atcBtn.getAttribute('form')) form = document.getElementById(atcBtn.getAttribute('form'));
    var isQuickAdd = atcBtn.classList.contains('js-quick-add');

    var idEl = (form && form.querySelector('[name="id"]')) || document.querySelector('[name="id"]');
    var variantId = atcBtn.dataset.variantId || (idEl && idEl.value);
    if (!variantId) return;

    /* Menge NUR aus dem zugehörigen Produktformular lesen; Karten = 1. */
    var qty = 1;
    if (!isQuickAdd) {
      var scope = form || atcBtn.closest('.product-info') || document;
      var qEl = scope.querySelector('[name="quantity"], .qty-stepper__input');
      var parsed = parseInt(qEl && qEl.value, 10);
      if (parsed > 0) qty = parsed;
    }

    atcBtn.disabled = true;
    cartMutate('/cart/add.js', { id: variantId, quantity: qty })
      .then(function (res) {
        if (res && res.sections) {
          renderDrawer(res.sections['cart-drawer']);
          openDrawer('cart-drawer');
          return syncCount();
        }
        /* Fehler (z. B. ausverkauft → 422 mit description) sichtbar machen */
        openDrawer('cart-drawer');
        cartFlash((res && res.description) || 'Hinzufügen derzeit nicht möglich.');
      })
      .catch(function () {
        openDrawer('cart-drawer');
        cartFlash('Netzwerkfehler. Bitte erneut versuchen.');
      })
      .finally(function () { atcBtn.disabled = false; });
  });

  /* Mengen-Änderung einer Drawer-Zeile (entprellt → schnelles +/- überlappt nicht) */
  var lineTimers = {};
  var removing = {};
  function changeLine(key, qty) {
    if (!key) return;
    clearTimeout(lineTimers[key]); delete lineTimers[key];
    cartMutate('/cart/change.js', { id: key, quantity: qty }).then(function (cart) {
      if (cart && typeof cart.item_count === 'number') updateCartCount(cart.item_count);
      if (cart && cart.sections) renderDrawer(cart.sections['cart-drawer']);
    }).catch(function () {}).then(function () { delete removing[key]; });
  }
  function queueLineChange(key, qty) {
    if (!key) return;
    clearTimeout(lineTimers[key]);
    lineTimers[key] = setTimeout(function () { changeLine(key, qty); }, 320);
  }

  /* Menge per Tastatur eingetippt — LEERES/ungültiges Feld NICHT als 0 (=Löschen) werten,
     sondern auf den letzten gültigen Wert zurücksetzen. Entfernen läuft nur über das X. */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.js-qty-input');
    if (!input) return;
    var raw = (input.value || '').trim();
    var qty = parseInt(raw, 10);
    if (raw === '' || isNaN(qty) || qty < 1) {
      input.value = input.dataset.lastQty || input.getAttribute('value') || 1;
      return;
    }
    var max = parseInt(input.max, 10);
    if (max > 0 && qty > max) { qty = max; input.value = max; }
    input.dataset.lastQty = qty;
    queueLineChange(input.dataset.key, qty);
  });

  /* +/- Stepper im Drawer (mit Ober-/Untergrenze) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-qty-minus, .js-qty-plus');
    if (!btn) return;
    var stepper = btn.closest('.qty-stepper');
    var input = stepper ? stepper.querySelector('.js-qty-input') : null;
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    var max = parseInt(input.max, 10);
    var next = btn.classList.contains('js-qty-minus') ? Math.max(1, val - 1) : val + 1;
    if (max > 0 && next > max) next = max;
    input.value = next;
    if (next >= 1) input.dataset.lastQty = next;
    queueLineChange(input.dataset.key, next);
  });

  /* Artikel entfernen (X) — sofort, doppelklick-sicher */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.js-cart-remove');
    if (!rm) return;
    e.preventDefault();
    var key = rm.dataset.key;
    if (!key || removing[key]) return;
    removing[key] = true;
    clearTimeout(lineTimers[key]); delete lineTimers[key];
    var line = rm.closest('.cart-line');
    if (line) { line.style.opacity = '0.4'; line.style.pointerEvents = 'none'; }
    changeLine(key, 0);
  });

  /* Bestellnotiz im Drawer speichern (entprellt) — ohne Re-Render, damit der Fokus bleibt */
  var noteTimer = null;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('.js-cart-note');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {});
    }, 600);
  });

  /* ── Reveal Animations ── */
  function initReveal(root) {
    root = root || document;
    var els = root.querySelectorAll('.reveal');
    if (!els.length) return;

    if (window.IntersectionObserver) {
      var seen = new WeakSet();
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var first = !seen.has(entry.target);
          seen.add(entry.target);
          if (!entry.isIntersecting) return;
          var vh = (entry.rootBounds && entry.rootBounds.height) || window.innerHeight;
          // Wie bisher: sofort, wenn beim Laden schon im Bild, sonst ab 12 % Sichtbarkeit.
          // Neu (24.09.2026): Elemente, die höher als der Bildschirm sind (Blogtext ~8000 px),
          // erreichen 12 % nie und blieben auf dem Handy unsichtbar → zeigen, sobald sie ins Bild kommen.
          if (first || entry.intersectionRatio >= 0.12 || entry.boundingClientRect.height > vh) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: [0, 0.12], rootMargin: '0px 0px -40px 0px' });

      els.forEach(function (el) { revealObserver.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }
  initReveal(document);

  /* Theme-Editor: neu geladene/bearbeitete Sections sofort sichtbar machen,
     damit Inhalte nicht unsichtbar (opacity:0) im Editor hängen bleiben */
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target || document;
    target.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  });

  /* ── Back to Top ── */
  var btt = document.querySelector('.js-back-to-top');
  if (btt) {
    window.addEventListener('scroll', function () {
      btt.classList.toggle('is-visible', window.scrollY > 500);
    }, { passive: true });
    btt.addEventListener('click', function () {
      var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: rm ? 'auto' : 'smooth' });
    });
  }

  /* ── Video play ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-play-video');
    if (!btn) return;
    var container = document.getElementById(btn.dataset.target);
    var url = btn.dataset.url;
    if (!container || !url) return;
    var isYoutube = url.includes('youtube') || url.includes('youtu.be');
    var isVimeo   = url.includes('vimeo');
    var embedSrc  = '';
    if (isYoutube) {
      var vid = url.match(/(?:v=|youtu\.be\/)([^&\s]+)/)?.[1];
      if (vid) embedSrc = 'https://www.youtube.com/embed/' + vid + '?autoplay=1';
    } else if (isVimeo) {
      var vid = url.match(/vimeo\.com\/(\d+)/)?.[1];
      if (vid) embedSrc = 'https://player.vimeo.com/video/' + vid + '?autoplay=1';
    }
    if (embedSrc) {
      container.innerHTML = '<iframe class="section-video__iframe" src="' + embedSrc + '" allow="autoplay; fullscreen" allowfullscreen style="width:100%;height:100%;border:0;aspect-ratio:16/9;display:block;"></iframe>';
    }
  });

  /* ── Copy code ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-copy-code');
    if (!btn) return;
    navigator.clipboard.writeText(btn.dataset.code).then(function () {
      btn.style.opacity = '1';
      setTimeout(function () { btn.style.opacity = ''; }, 1500);
    });
  });

  /* Globales Drawer-API für externe Section-Scripts (z. B. Angebots-Drawer) */
  window.DrawerManager = { open: openDrawer, close: closeDrawer };

})();
